import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "../lang/en.json";
import ptTranslation from "../lang/pt.json";
import deTranslation from "../lang/de.json";
import frTranslation from "../lang/fr.json";
import itTranslation from "../lang/it.json";
import esTranslation from "../lang/es.json";

i18n.use(initReactI18next).init({
  fallbackLng: "pt",
  lng: localStorage.getItem("lng") || "pt",

  resources: {
    en: { translation: enTranslation },
    pt: { translation: ptTranslation },
    de: { translation: deTranslation },
    fr: { translation: frTranslation },
    it: { translation: itTranslation },
    es: { translation: esTranslation },
  },

  interpolation: {
    escapeValue: false,
  },

  saveMissing: false,
  load: "languageOnly",
});

// Keep <html lang="..."> in sync with the active language for SEO + a11y.
const syncHtmlLang = (lng) => {
  const code = (lng || "pt").substring(0, 2);
  if (typeof document !== "undefined" && document.documentElement.getAttribute("lang") !== code) {
    document.documentElement.setAttribute("lang", code);
  }
};
syncHtmlLang(i18n.language);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
